<section id="clientMessage">
</section>
<section class="hero">
    <div class="hero-inner">
        <div class="container">
            <div class="row">
                <div class="col-xs-12" style="margin-left: auto; margin-right: auto; text-align: center">
                    <!--div(style="margin-left: 8vw; margin-right: 8vw")-->
                    <div style="margin-left: auto; margin-right: auto; text-align: center">
                        <div class="hero-logo" style="margin-top: 13vh;"><img src="../../../assets/cls-sphere.jpg"
                                alt="CLS Logo" width="80" /></div>
                        <div style="display: flex;">
                            <div style="margin-top: 30px;">
                                <h1 class="title section-title hero-title">Welcome to<br /><span
                                        style="color: #878787;">CLS Group Services</span></h1>
                                <p class="hero-subtitle" style="max-width: 560px;">CLS Group Services offers outstanding
                                    shared service solutions for the CLS Group. Our expertise and multi-disciplined
                                    teams give us a wealth of shared data and knowledge which enables us to provide the
                                    CLS Group with a
                                    partner to truly rely on. We understand that great solutions are built together.</p>
                                <br /><button class="cls-btn hero-primary" type="button" (click)="scroll('usp')">CHOOSE
                                    US</button><button class="cls-btn hero-primary-outline" type="button"
                                    style="margin-left: 15px" (click)="scroll('footer')">GET IN TOUCH</button>
                            </div>
                        </div>
                        <div class="overl-res d-none d-md-block"><img class="fadeOverlay" id="overlay"
                                src="./assets/CLS-GS/Group-Services-Overlay.png"
                                style="position:absolute; bottom:60px; right: 0; z-index: 0; height: 30vh; width: 100vw;" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<section class="infographics-section" id="usp"
    style="margin-top: 0px;padding-top: 60px; margin-bottom: 30px; background: #ffffff; background-image: -webkit-linear-gradient(top, #e7e9e9 25%, #ffffff 100%);">
    <div class="container-fluid">
        <div class="row" style="text-align: center; color: #3d4d62; margin-left: auto; margin-right: auto;">
            <div class="col-12">
                <h1 class="section-title" style="margin-bottom: 50px; margin-top:30px;">Choose<span
                        style="color: #878787"> Us </span></h1>
            </div>
        </div>
        <div class="row"
            style="text-align: center; color: #3d4d62; margin-left: auto; margin-right: auto; max-width:950px;">
            <!--1-->
            <div class="col-xs-12 col-sm-12 col-md-4" style="padding-top: 25px; padding-bottom: 25px;"><img
                    class="img-fluid" src="./assets/CLS-GS/usp/Group 1539@2x.png" /></div>
            <!--2-->
            <div class="col-xs-12 col-sm-12 col-md-4" style="padding-top: 25px; padding-bottom: 25px;"><img
                    class="img-fluid" src="./assets/CLS-GS/usp/Group 1331@2x.png" /></div>
            <!--3-->
            <div class="col-xs-12 col-sm-12 col-md-4" style="padding-top: 25px; padding-bottom: 25px;"><img
                    class="img-fluid" src="./assets/CLS-GS/usp/Group 1426@2x.png" /></div>
        </div>
        <div class="row"
            style="text-align: center; color: #3d4d62; margin-left: auto; margin-right: auto; margin-bottom: 70px; max-width:950px;">
            <!--4-->
            <div class="col-xs-12 col-sm-12 col-md-4 offset-md-2" style="padding-top: 25px; padding-bottom: 25px;"><img
                    class="img-fluid" src="./assets/CLS-GS/usp/Group 1437@2x.png" /></div>
            <!--5-->
            <div class="col-xs-12 col-sm-12 col-md-4" style="padding-top: 25px; padding-bottom: 25px;"><img
                    class="img-fluid" src="./assets/CLS-GS/usp/Group 1328@2x.png" /></div>
            <div class="col-1 d-none d-lg-block"><br /></div>
        </div>
    </div>
</section>
<section style="padding-top: 40px; min-height: 500px; background: #eeeff3; padding-bottom: 50px">
    <div style="text-align: center;">
        <h1 style="position: relative; top: 20px;">Our<span style="color: #878787"> Services</span></h1>
    </div>
    <div class="container">
        <div class="row text-center selectors">
            <div class="col-12" style="margin-bottom: 0;">
                <ul class="nav nav-tabs" style="margin-top: 60px; margin-left: auto; margin-right: auto">
                    <li class="nav-item" style="margin-left: auto; margin-right: auto"> <a class="nav-link"
                            (click)="selectedSlice=0" [ngClass]="selectedSlice==0?'activeTab-link':''">IT Systems</a>
                    </li>
                    <li class="nav-item" style="margin-left: auto; margin-right: auto"> <a class="nav-link"
                            (click)="selectedSlice=1" [ngClass]="selectedSlice==1?'activeTab-link':''">HR</a></li>
                    <li class="nav-item" style="margin-left: auto; margin-right: auto"> <a class="nav-link"
                            (click)="selectedSlice=2" [ngClass]="selectedSlice==2?'activeTab-link':''">Development</a>
                    </li>
                    <li class="nav-item" style="margin-left: auto; margin-right: auto"> <a class="nav-link"
                            (click)="selectedSlice=3" [ngClass]="selectedSlice==3?'activeTab-link':''">Project
                            Management</a></li>
                    <li class="nav-item" style="margin-left: auto; margin-right: auto"> <a class="nav-link"
                            (click)="selectedSlice=4" [ngClass]="selectedSlice==4?'activeTab-link':''">Finance</a></li>
                    <li class="nav-item" style="margin-left: auto; margin-right: auto"> <a class="nav-link"
                            (click)="selectedSlice=5" [ngClass]="selectedSlice==5?'activeTab-link':''">Compliance</a>
                    </li>
                    <li class="nav-item" style="margin-left: auto; margin-right: auto"> <a class="nav-link"
                            (click)="selectedSlice=6" [ngClass]="selectedSlice==5?'activeTab-link':''">Marketing</a>
                    </li>
                </ul>
            </div>
        </div>
        <div class="row text-center small-selectors" style="padding-top: 60px;">
            <div style="width:42px; margin-left: auto; margin-right: auto;"><button
                    class="btn btn-circle primary-outline" [ngClass]="{'btn-circle-selected':selectedSlice==0}"
                    (click)="selectedSlice=0"></button></div>
            <div style="width:42px; margin-left: auto; margin-right: auto;"><button
                    class="btn btn-circle primary-outline" [ngClass]="{'btn-circle-selected':selectedSlice==1}"
                    (click)="selectedSlice=1"></button></div>
            <div style="width:42px; margin-left: auto; margin-right: auto;"><button
                    class="btn btn-circle primary-outline" [ngClass]="{'btn-circle-selected':selectedSlice==2}"
                    (click)="selectedSlice=2"></button></div>
            <div style="width:42px; margin-left: auto; margin-right: auto;"><button
                    class="btn btn-circle primary-outline" [ngClass]="{'btn-circle-selected':selectedSlice==3}"
                    (click)="selectedSlice=3"></button></div>
            <div style="width:42px; margin-left: auto; margin-right: auto;"><button
                    class="btn btn-circle primary-outline" [ngClass]="{'btn-circle-selected':selectedSlice==4}"
                    (click)="selectedSlice=4"></button></div>
            <div style="width:42px; margin-left: auto; margin-right: auto;"><button
                    class="btn btn-circle primary-outline" [ngClass]="{'btn-circle-selected':selectedSlice==5}"
                    (click)="selectedSlice=5"></button></div>
            <div style="width:42px; margin-left: auto; margin-right: auto;"><button
                    class="btn btn-circle primary-outline" [ngClass]="{'btn-circle-selected':selectedSlice==6}"
                    (click)="selectedSlice=6"></button></div>
        </div>
        <div class="row">
            <div class="col-md-12 col-lg-6 piecolumn">
                <div style="position: relative"><img src="../../../assets/cls-logo-sphere.png" alt="CLS logo" width="80"
                        style="position: absolute; top: 237px; left: 230px;" /></div>
                <div id="piechart" style="width: 100%; height:100%; width: 540px; height: 684px;"></div>
            </div>
            <div class="col-md-12 col-lg-6 descriptioncolumn">
                <div style="margin-top: 80px;">
                    <div *ngIf="selectedSlice == 0">
                        <h5> <strong>Information Technology </strong></h5>
                        <p style="font-size: 14px; color: #6B7072">CLS GS IT department can provide IT Governance,
                            infrastructure management and general IT functions.</p>
                        <p style="font-size: 14px; color: #6B7072">IT Governance ensures rules and regulations of
                            technology and data usage are enacted to meet business and regulatory requirements, while
                            infrastructure management includes but is not limited to the management of on-premise
                            systems,
                            networking, printing, telephony, cloud-based systems and services, and mobile telephony.</p>
                        <p style="font-size: 14px; color: #6B7072">In addition to this, the department ensures the
                            productive use of resources, facilitates data management and information systems security,
                            and provides general user technical support.</p>
                        <p style="font-size: 14px; color: #6B7072">The department also ensures the ongoing functioning
                            of applications software while providing technical support to users on the software.</p>
                        <div style="margin-top: 10px">
                            <div style="display: inline"><img src="../../../assets/members/development.png" width="170"
                                    style="vertical-align: top; border: 6px solid #024693; border-radius: 100px" />
                            </div>
                            <div style="display: inline-block; margin-left: 25px;">
                                <p style="padding-top: 15px; font-size: 14px; color: #6B7072">Specialist: IT Team</p><a
                                    href="mailto:ITsupport@clsl.co.uk">ITsystems@clsl.co.uk</a><br /><a href="#">+44(0)
                                    1732 753 910</a><br />
                            </div>
                        </div>
                    </div>
                    <div *ngIf="selectedSlice == 1">
                        <h5> <strong>Human Resources </strong></h5>
                        <p style="font-size: 14px; color: #6B7072">HR is so much more than just the stereotypical
                            recruitment, training and employee relations.</p>
                        <p style="font-size: 14px; color: #6B7072">The benefits of having a strong employer brand are
                            compelling. It differentiates you from your competitors and it marks you out as an employer
                            of choice.</p>
                        <p style="font-size: 14px; color: #6B7072">In the business world, it is people who make our
                            organisations what they are. As products become increasingly standardised, it’s the service
                            provided by humans that represents our last key conquest on the battlefield of
                            differentiation.
                            How you treat your employees – past, present and future – defines your employer brand.</p>
                        <p style="font-size: 14px; color: #6B7072">CLS GS HR function is not simply a support function
                            there to process, regulate and mop up, we can demonstrate that we are commercially driven
                            and poised to add value to your organisations.</p>
                        <div style="margin-top: 10px">
                            <div style="display: inline"><img src="../../../assets/members/development.png" width="170"
                                    style="vertical-align: top; border: 6px solid #024693; border-radius: 100px" />
                            </div>
                            <div style="display: inline-block; margin-left: 25px;">
                                <p style="padding-top: 15px; font-size: 14px; color: #6B7072">&nbsp;
                                </p><a href="mailto:HR@clsl.co.uk">HR@clsl.co.uk</a><br /><a href="#">+44(0) 1732 753
                                    910</a><br />
                            </div>
                        </div>
                    </div>
                    <div *ngIf="selectedSlice == 2">
                        <h5> <strong>Development</strong></h5>
                        <p style="font-size: 14px; color: #6B7072">CLS can provide an array of mapping services to help
                            a client on a national level. By displaying our full suite of Title and Hazard data we give
                            the client a valuable form of risk management across varying degrees of granularity.</p>
                        <p style="font-size: 14px; color: #6B7072">CLS GS can help with every stage of your business
                            journey. Starting with listening to your ideas and challenges, we will collaborate to design
                            solutions to achieve your requirements in reasonable time frames. Your solution will
                            then be transparently developed either in one rapid iteration or iteratively responding to
                            potentially changing requirements and business goals.</p>
                        <div style="margin-top: 10px">
                            <div style="display: inline"><img src="../../../assets/members/development.png" width="170"
                                    style="vertical-align: top; border: 6px solid #024693; border-radius: 100px" />
                            </div>
                            <div style="display: inline-block; margin-left: 25px;">
                                <p style="padding-top: 15px; font-size: 14px; color: #6B7072">&nbsp;</p><a
                                    href="mailto:Development@clsl.co.uk">Development@clsl.co.uk</a><br /><a
                                    href="#">+44(0) 1732 753 910</a><br />
                            </div>
                        </div>
                    </div>
                    <div *ngIf="selectedSlice == 3">
                        <h5> <strong>Project Management</strong></h5>
                        <p style="font-size: 14px; color: #6B7072">In order for all companies to grow and thrive, there
                            must be an element of change and innovation. With that, organisation and planning are
                            essential for success.</p>
                        <p style="font-size: 14px; color: #6B7072">CLS GS have the knowledge, skills and experience to
                            offer Project Management services which enable our clients to make informed decisions
                            regarding viability and value of their proposed ideas, provide them with full transparency
                            over the lifecycle of their change, and identify key stages in the planning and execution of
                            projects.</p>
                        <p style="font-size: 14px; color: #6B7072">From identification of a requirement, we work with
                            business and product owners to help analyse and refine ideas, understand which core items
                            will most efficiently deliver the highest benefit, and transpose them into meaningful
                            development work items.</p>
                        <p style="font-size: 14px; color: #6B7072">Throughout the project, actions and dependencies are
                            continuously monitored, stakeholder expectations managed, and obstacles and risks identified
                            and mitigated to ensure the smoothest possible delivery of a successful project.</p>
                        <div style="margin-top: 10px">
                            <div style="display: inline"><img src="../../../assets/members/development.png" width="170"
                                    style="vertical-align: top; border: 6px solid #024693; border-radius: 100px" />
                            </div>
                            <div style="display: inline-block; margin-left: 25px;">
                                <p style="padding-top: 15px; font-size: 14px; color: #6B7072">&nbsp;</p><a
                                    href="mailto:PMO@clsl.co.uk">PMO@clsl.co.uk</a><br /><a href="#">+44(0) 1732 753
                                    910</a><br />
                            </div>
                        </div>
                    </div>
                    <div *ngIf="selectedSlice == 4">
                        <h5> <strong>Finance </strong></h5>
                        <p style="font-size: 14px; color: #6B7072">The CLS GS Finance department provides a wide range
                            of accounting solutions to our business partners, from transactional processing through to
                            meaningful financial reporting and analysis to business owners.   </p>
                        <p style="font-size: 14px; color: #6B7072">As a team, we have a range of knowledge and
                            experience to help drive your business forward and we pride ourselves on being reactive and
                            supportive to our business partners' requirements.</p>
                        <p style="font-size: 14px; color: #6B7072">We work with you to ensure that all client and
                            supplier relationships are maintained and take the day to day headaches away from you.</p>
                        <p style="font-size: 14px; color: #6B7072">We also provide a variety of services related to
                            business payroll. This includes management of benefits and pensions, maintaining accurate
                            payroll accounting records but most importantly ensuring employees are paid correctly, on
                            time
                            and HMRC obligations are met.</p>
                        <div style="margin-top: 10px">
                            <div style="display: inline"><img src="../../../assets/members/development.png" width="170"
                                    style="vertical-align: top; border: 6px solid #024693; border-radius: 100px" />
                            </div>
                            <div style="display: inline-block; margin-left: 25px;">
                                <p style="padding-top: 15px; font-size: 14px; color: #6B7072">&nbsp;</p><a
                                    href="mailto:Accounts@clsl.co.uk">Accounts@clsl.co.uk</a><br /><a href="#">+44(0)
                                    1732 753 910</a><br />
                            </div>
                        </div>
                    </div>
                    <div *ngIf="selectedSlice == 5">
                        <h5> <strong>Compliance</strong></h5>
                        <p style="font-size: 14px; color: #6B7072">Falling foul of FCA rules and changes in regulations
                            makes it easy for your business to pick up penalty fines and even gain a bad reputation
                            across the market. But keeping your business compliant and up to date needn’t be a constant
                            source of stress. CLS GS Compliance has the expertise to assist your business in maintaining
                            compliance whilst allowing you to remain process efficient in keeping with the style of your
                            business.</p>
                        <p style="font-size: 14px; color: #6B7072">Our services include - due diligence checks;
                            regulatory reporting; developing, monitoring and reporting on all company policies and
                            procedures. These measures will ensure that your business has a sufficient framework to
                            maintain a
                            compliant status. </p>
                        <div style="margin-top: 10px">
                            <div style="display: inline"><img src="../../../assets/members/development.png" width="170"
                                    style="vertical-align: top; border: 6px solid #024693; border-radius: 100px" />
                            </div>
                            <div style="display: inline-block; margin-left: 25px;">
                                <p style="padding-top: 15px; font-size: 14px; color: #6B7072">&nbsp;
                                </p><a href="mailto:Compliance@clsl.co.uk">Compliance@clsl.co.uk</a><br /><a
                                    href="#">+44(0) 1732 753 910</a><br />
                            </div>
                        </div>
                    </div>
                    <div *ngIf="selectedSlice == 6">
                        <h5> <strong>Marketing</strong></h5>
                        <p style="font-size: 14px; color: #6B7072">The Marketing team at CLS GS have expertise in
                            strategy, design, communications and event management. Working in response to business
                            requirements and competitor analysis, we manage multi-channel marketing campaigns and
                            product launches
                            to promote products and services.  </p>
                        <p style="font-size: 14px; color: #6B7072">Via online and offline marketing, we can offer such
                            services as production of brochures and product cards, website content, social media,
                            articles, press releases, advertising, and tailored communications. We organise and host a
                            number
                            of events each year, including corporate hospitality, webinars and seminars and support for
                            exhibitions or conference events, typically for reseller, broker, solicitor and developer
                            clients.</p>
                        <div style="margin-top: 10px">
                            <div style="display: inline"><img src="../../../assets/members/development.png" width="170"
                                    style="vertical-align: top; border: 6px solid #024693; border-radius: 100px" />
                            </div>
                            <div style="display: inline-block; margin-left: 25px;">
                                <p style="padding-top: 15px; font-size: 14px; color: #6B7072">&nbsp;
                                </p><a href="mailto:Marketing@clsl.co.uk">Marketing@clsl.co.uk</a><br /><a
                                    href="#">+44(0) 1732 753 910</a><br />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<section>
    <div class="container">
        <div class="row">
            <div class="col-12">
                <div style="text-align: center; margin-top: 80px; margin-bottom: 80px">
                    <h1>Working <span style="color: #878787"> with...</span></h1><br /><img class="os"
                        src="./assets/working-with-logos/OS.png" /><img class="landreg"
                        src="./assets/working-with-logos/landreg.png" /><img class="bluesky"
                        src="./assets/working-with-logos/bluesky.png" />
                </div>
            </div>
        </div>
    </div>
</section>